'use client'

const THEME_KEY = '@antd/app-theme'

export const useTheme = () => {
  const theme = localStorage.getItem(THEME_KEY) || 'light'

  const toggleTheme = () => {
    const newTheme = theme === 'light' ? 'dark' : 'light'

    localStorage.setItem(THEME_KEY, newTheme)
  }

  return { theme, toggleTheme }
}
